import actions from './actions'

const fireRollCall = (state = { fireRollCallList: [], refreshDateTime: '' }, action) => {
  switch (action.type) {
    case actions.setFireRollCall:
      return {
        fireRollCallList: action.fireRollCall.fireRollCallList,
        refreshDateTime: action.fireRollCall.refreshDateTime
      }
    case actions.fetchPending:
      return { loading: true, list: [] }
    case actions.resetFireRollCall:
      return {
        fireRollCallList: [],
        refreshDateTime: ''
      }
    default:
      return state
  }
}

export default fireRollCall



// WEBPACK FOOTER //
// ./src/store/fire-roll-call/reducer.js